module.exports = __webpack_public_path__ + "img/cpjs-img2.dcb82bcb.png";